import React from "react"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"
import Button from "shared/components/Button/Button"

import styles from "./styles.css"

function FooterForm({
  onClickNext,
  onClickPrevious,
  step,
  disabled,
  textPrevious,
  textNext,
  type
}) {
  return (
    <div>
      <Typograph
        htmlTag="p"
        size="medium"
        weight="medium"
        color="outer_space"
        classNames={styles.step}
      >
        Etapa {step} de 3
      </Typograph>

      <div className={styles.buttonsContainer}>
        <Button
          type="button"
          buttonStyle="secondary"
          width="small"
          onClick={onClickPrevious}
        >
          {textPrevious}
        </Button>

        <Button
          buttonStyle="primary"
          width="small"
          onClick={onClickNext}
          disabled={disabled}
          type={type}
        >
          {textNext}
        </Button>
      </div>
    </div>
  )
}

FooterForm.propTypes = {
  onClickNext: PropTypes.func,
  onClickPrevious: PropTypes.func,
  step: PropTypes.string,
  disabled: PropTypes.bool,
  textNext: PropTypes.string,
  textPrevious: PropTypes.string,
  type: PropTypes.string
}
export default FooterForm



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/components/FooterForm/index.js